import { ChartOfAccountTypeEnum } from "./chart-of-account-type-enum";

export const chartOfAccountTypeLabels = {
  [ChartOfAccountTypeEnum.CASH_AND_BANK]: "Kas & Bank",
  [ChartOfAccountTypeEnum.ACCOUNTS_RECEIVABLE]: "Piutang Usaha",
  [ChartOfAccountTypeEnum.INVENTORY]: "Persediaan",
  [ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS]: "Aset Lancar Lainnya",
  [ChartOfAccountTypeEnum.FIXED_ASSETS]: "Aset Tetap",
  [ChartOfAccountTypeEnum.ACCUMULATED_DEPRECIATION]: "Akumulasi Penyusutan",
  [ChartOfAccountTypeEnum.OTHER_ASSETS]: "Aset Lainnya",
  [ChartOfAccountTypeEnum.ACCOUNTS_PAYABLE]: "Utang Usaha",
  [ChartOfAccountTypeEnum.CURRENT_LIABILITIES]: "Liabilitas Jangka Pendek",
  [ChartOfAccountTypeEnum.LONG_TERM_LIABILITIES]: "Liabilitas Jangka Panjang",
  [ChartOfAccountTypeEnum.EQUITY]: "Modal",
  [ChartOfAccountTypeEnum.REVENUE]: "Pendapatan",
  [ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD]: "Beban Pokok Penjualan",
  [ChartOfAccountTypeEnum.EXPENSES]: "Beban",
  [ChartOfAccountTypeEnum.OTHER_EXPENSES]: "Beban Lainnya",
  [ChartOfAccountTypeEnum.OTHER_INCOME]: "Pendapatan Lainnya",
};
